import { Box, Button } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  onApply: () => void;
  onReset: () => void;
  isApplyDisabled?: boolean;
};

export const FilterActions = ({
  onApply,
  onReset,
  isApplyDisabled = false,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" gap={2}>
      <Button
        variant="outlined"
        fullWidth
        onClick={onReset}
        sx={{ borderRadius: 2 }}
      >
        {t(RESOURCES.Reset)}
      </Button>
      <Button
        variant="contained"
        fullWidth
        onClick={onApply}
        disabled={isApplyDisabled}
        sx={{ borderRadius: 2 }}
      >
        {t(RESOURCES.Apply)}
      </Button>
    </Box>
  );
};
